<template>
    <ReactPage>
      <isms-code-data-report-page></isms-code-data-report-page>
    </ReactPage>
  </template>
  
  <script>
  import ReactPage from '../components/ReactPage.vue';
  
  export default {
    name: "ISMSCodeDataReport",
    components: {
      ReactPage
    }
  }
  </script>